import React from 'react';
import { Discount } from '../../../../types/discounts';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import checkIcon from './check.svg';

interface StampsProps extends WithTranslation {
    discount: Discount;
}

const Stamps = (
    {
        discount,
        t,
    }: StampsProps
) => {
    if (!discount.requirement.stamp) return null;

    const { requirement: { stamp: stampsRequired } } = discount;
    // @ts-ignore
    const { statistics: { current_stamp: customerStamps = 0 } } = discount;

    return (
        <>
            <StampsContainer>
                {[...Array(stampsRequired)].map((_, i) => {
                    return (i < customerStamps) ? (
                        <StampItem key={`${discount.id}-${i}`}>
                            <UsedStamp>
                                <img src={checkIcon} alt="Check"/>
                            </UsedStamp>
                        </StampItem>
                    ) : (
                        <StampItem key={`${discount.id}-${i}`}>
                            <UnusedStamp/>
                        </StampItem>
                    );
                })}
            </StampsContainer>
            <StampLabel>
                {t('customers.customer.discounts.stamp_label', {
                    customerStamps,
                    stampsRequired,
                })}
            </StampLabel>
        </>
    );
};

const StampsContainer = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 24px;
    display: flex;
    align-items: center;
`;

const StampItem = styled.li`
    display: inline-block;
    & + & {
        margin-left: 8px;
    }
`;

const UnusedStamp = styled.span`
    border: 2px solid #495E61;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: inline-block;
`;

const UsedStamp = styled.span`
    background: #495E61;
    display: inline-block;
    border: 2px solid #495E61;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StampLabel = styled.span`
    font-size: 11px;
    color: #46535E;
    display: block;
    margin-top: 16px;
`;

export default withTranslation()(Stamps);
